export default __webpack_public_path__ + "static/media/gel-buffer-23.6e2eaf2d.svg";